module.exports = __webpack_public_path__ + "media/images/icon_tw-e227131357a5845d5e6893b432ef43f0.png";